import { GifBoxRounded } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef } from "react";
import Message from "./Message";

interface IMessage {
  attachment?: string;
  isMine: boolean;
  message: string;
  message_id: number;
  sent_time: string;
  user_avatar: string;
  user_name: string;
}

export default function ChatBody({ messages, loading }: { messages: IMessage[], loading: any }) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    scrollToBottom()
  }, [messages]);


  return (
    <Box
      sx={{
        width: "100%", maxHeight: "60vh",
        minHeight: "60vh", overflow: "auto",
        ...(loading ? { display: "grid", placeContent: "center" } : {})
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ p: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
          {messages.map((message, index) => {
            const prevMessage = messages[index - 1];
            const displayAvatarInEndOfMessages = !prevMessage || prevMessage.isMine !== message.isMine;

            return (
              <Message key={index} message={message} displayAvatar={displayAvatarInEndOfMessages} />
            )
          })}
          <div  style={{ float:"left", clear: "both" }} ref={messagesEndRef} />
        </Box>
      )}
    </Box>
  );
}
